@if (hasTabs()) {
  <div class="style-{{style}}">
    <div class="tabs-container" role="tablist">
      @for (tab of tabs(); track tab) {
        <a class="tab {{tab.id}}-tab" role="tab" [class.highlight-tab]="tab.highlighted"
          [attr.aria-selected]="tab.highlighted" [routerLink]="tab.routerLinkCommands" [appBlurWhen]="navigated">
          {{tab.title}}
        </a>
      }
    </div>
    @if (hasSubtabs()) {
      <div class="subtabs-container" role="tablist">
        @for (tab of subtabs(); track tab) {
          <a class="tab {{tab.id}}-tab" role="tab" [class.highlight-tab]="tab.highlighted"
            [attr.aria-selected]="tab.highlighted" [routerLink]="tab.routerLinkCommands" [appBlurWhen]="navigated">
            {{tab.title}}
          </a>
        }
      </div>
    }
    <nav class="dropdown-container" [class.opened]="dropdownOpen()">
      <button type="button" class="dropdown-button" [attr.aria-label]="dropdownAriaLabel()" (click)="toggleDropdown()">
        <span class="text">{{dropdownTitle()}}</span>
        <img class="icon" src="assets/icons/common/arrow-down.svg" alt="">
      </button>
      <div class="dropdown-options">
        @for (tab of tabs(); track tab) {
          <a [routerLink]="tab.routerLinkCommands"
            class="option {{tab.id}}-option"
            [class.highlight-option]="tab.active"
            [attr.aria-label]="tab.ariaLabel"
            (click)="toggleDropdown()">
            {{tab.title}}
          </a>
          @for (subtab of tab.children; track subtab) {
            <a [routerLink]="subtab.routerLinkCommands"
              class="option suboption {{subtab.id}}-option"
              [class.highlight-option]="subtab.active"
              [attr.aria-label]="subtab.ariaLabel"
              (click)="toggleDropdown()">
              {{subtab.title}}
            </a>
          }
        }
      </div>
    </nav>
  </div>
}
